import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import { parseYMDMomentTimezoneConfig } from "../../../../datetime";

export default class LinePerMonth extends PureComponent {
  render() {
    const { monthVisitMap, dataKey = "count" } = this.props;

    if (!monthVisitMap) {
      return "n/a";
    }

    const data = Object.entries(monthVisitMap).reduce(
      (acc, [month, monthData]) => [
        ...acc,
        {
          month: parseYMDMomentTimezoneConfig(month).format("MMM YYYY"),
          [dataKey]: monthData[dataKey]
        }
      ],
      []
    );

    return (
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="month"
            interval={0}
            angle={-45}
            textAnchor="end"
            height={50}
            tick={{ fontSize: 10 }}
          />
          <YAxis />
          <Tooltip />
          <Line dataKey={dataKey} fill="#8884d8" />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}
